export default __webpack_public_path__ + "static/media/102-desktop.0aa341bc.jpg";